(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["craft-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-craft-testimonials]';

    const initialise = (section) => {
      if (!section || section.dataset.craftTestimonialsReady === 'true') return;

      const viewport = section.querySelector('[data-craft-testimonial-viewport]');
      const track = section.querySelector('[data-craft-testimonial-track]');
      const previousButton = section.querySelector('[data-craft-testimonial-prev]');
      const nextButton = section.querySelector('[data-craft-testimonial-next]');
      const currentElement = section.querySelector('[data-craft-testimonial-current]');
      const totalElement = section.querySelector('[data-craft-testimonial-total]');
      const slides = Array.from(track?.querySelectorAll('[data-craft-testimonial-slide]') || []);

      if (!viewport || !track || slides.length < 2) return;

      section.dataset.craftTestimonialsReady = 'true';

      const interval = 4250;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0;
      let timer;
      let touchResumeTimer;
      let visibleCount = 1;

      if (totalElement) totalElement.textContent = String(slides.length);

      const getVisibleCount = () => {
        if (window.matchMedia('(min-width: 990px)').matches) return 3;
        if (window.matchMedia('(min-width: 750px)').matches) return 2;
        return 1;
      };

      const updateCounter = () => {
        if (currentElement) currentElement.textContent = String((index % slides.length) + 1);
      };

      const move = (animate = true) => {
        const target = track.children[index];
        if (!target) return;
        track.style.transitionDuration = animate ? '520ms' : '0ms';
        track.style.transform = `translate3d(${-target.offsetLeft}px, 0, 0)`;
        updateCounter();
      };

      const removeClones = () => {
        track.querySelectorAll('[data-craft-testimonial-clone]').forEach((clone) => clone.remove());
      };

      const buildClones = () => {
        removeClones();
        visibleCount = Math.min(getVisibleCount(), slides.length);
        slides.slice(0, visibleCount).forEach((slide) => {
          const clone = slide.cloneNode(true);
          clone.setAttribute('data-craft-testimonial-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-craft-testimonial-slide');
          clone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
            element.setAttribute('tabindex', '-1');
          });
          track.appendChild(clone);
        });
        index = 0;
        move(false);
      };

      const stop = () => {
        window.clearInterval(timer);
        timer = undefined;
      };

      const start = () => {
        stop();
        if (!reducedMotion.matches) {
          timer = window.setInterval(() => {
            index += 1;
            move();
          }, interval);
        }
      };

      const next = () => {
        index += 1;
        move();
        start();
      };

      const previous = () => {
        if (index === 0) {
          index = slides.length;
          move(false);
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              index -= 1;
              move();
            });
          });
        } else {
          index -= 1;
          move();
        }
        start();
      };

      track.addEventListener('transitionend', () => {
        if (index >= slides.length) {
          index = 0;
          move(false);
        }
      });

      previousButton?.addEventListener('click', previous);
      nextButton?.addEventListener('click', next);
      section.addEventListener('pointerenter', stop);
      section.addEventListener('pointerleave', start);
      section.addEventListener('focusin', stop);
      section.addEventListener('focusout', start);
      viewport.addEventListener('touchstart', () => {
        window.clearTimeout(touchResumeTimer);
        stop();
      }, { passive: true });
      viewport.addEventListener('touchend', () => {
        window.clearTimeout(touchResumeTimer);
        touchResumeTimer = window.setTimeout(start, interval);
      }, { passive: true });
      reducedMotion.addEventListener('change', start);

      let resizeTimer;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
          if (visibleCount !== getVisibleCount()) buildClones();
          else move(false);
        }, 150);
      });

      buildClones();
      start();
    };

    document.querySelectorAll(selector).forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target.querySelector(selector)));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
